import {defaultChannel} from '@/config';
import globalStore from '@/services/global.state';

type TrackEventType =
  | 'login'
  | 'logout'
  | 'registerClick'
  | 'rechargeClick'
  | 'enterGame';

declare const window: {
  Android: any;
  jsBridge: any;
  onNotification: (data: any) => void;
  navigator: Navigator & {
    standalone: boolean;
  };
} & Window;

interface TrackRechargeParams {
  amount: number | string;
}

interface TrackEnterGameParams {
  gameName: string;
  gameId: string;
}

export function trackEvent(
  event: 'login' | 'registerClick' | 'logout',
  params?: undefined,
): void;
export function trackEvent(
  event: 'rechargeClick',
  params: TrackRechargeParams,
): void;
export function trackEvent(
  event: 'enterGame',
  params: TrackEnterGameParams,
): void;
export function trackEvent(
  event: TrackEventType,
  params?: TrackRechargeParams | TrackEnterGameParams,
) {
  try {
    const token = globalStore.token || localStorage.getItem('token');
    const userInfo =
      globalStore.userInfo || JSON.parse(localStorage.getItem('user') || '{}');
    const cid = globalStore.channel || defaultChannel;
    const newParams = {
      ...(params || {}),
      ...(token && userInfo && userInfo.userId
        ? {
            uid: userInfo.userId,
            phone: userInfo.userPhone || userInfo.accountNo,
          }
        : {}),
      cid,
    };
    if (window.jsBridge) {
      window.jsBridge.postMessage(event, JSON.stringify(newParams));
    }
    // console.log('trackEvent', event, newParams);
  } catch (error) {
    console.log('trackEvent error:', event);
  }
}
